<template>
  <div class="team-info lh1">
    <team-banner :info="info"></team-banner>
    <h3 class="center">{{info.teamName}}</h3>
    <div class="flex score" v-if="info.teamScoure">
      <div class="flex0 name">{{info.teamScoure|formatScore}}</div>
      <star class="flex0" :size="36" :score="info.teamScoure"></star>
      <router-link v-if="showRateList" :to="{path:'/team/'+info.id+'/rate'}" tag="div" class="flex0 text">查看
      </router-link>
    </div>
    <div class="center score-no" v-else>
      暂无评分
    </div>

    <p class="fs12 color_main flex-center-2 flex pt15" v-if="info.teamConsultAvgReplyTimeDescription">
      <span class="pt2 pb3 pl10 pr10">平均响应时间：{{info.teamConsultAvgReplyTimeDescription}}</span>
    </p>
  </div>
</template>

<script>
  import {formatScore} from "../../lib/filter";
  import Star from '../../base/star/star'
  import {teamAvaErrorMixin} from "../../lib/mixin";
  import TeamBanner from "./team-banner";

  export default {
    props: ['info', 'showRateList', 'thumb'],
    data() {
      return {};
    },
    computed: {},
    filters: {formatScore},
    components: {TeamBanner, Star},
    mixins: [teamAvaErrorMixin],
    created() {

    },
    mounted() {

    },
    beforeDestroy() {

    },
    methods: {}
  };
</script>

<style scoped lang="scss">
  @import "../../common/public";

  .team-info {
    background-color: white;
    padding-bottom: px2rem(15px);

    p {
      span {
        border-radius: 5px;
        border: 1px solid $mainColor;
      }
    }

    h3 {
      color: #333333;
      font-size: px2rem(17px);
      padding: px2rem(14px);
    }

    .score-no {
      font-size: px2rem(15px);
      color: #777777;
    }

    .score {
      justify-content: center;
      align-items: center;

      .name {
        color: #666666;
        font-size: px2rem(24px);
        margin-right: px2rem(10px);
      }

      .text {
        margin-left: px2rem(10px);
        font-size: px2rem(15px);
        color: $mainColor;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/plugins/team/info.vue